import React, { useState, useEffect } from "react";
import axios from "axios";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import { Link } from "react-router-dom";
import moment from "moment";
import { Modal, Button } from "react-bootstrap";
import PaymentModal from "../Client-Info/PaymentModel";
import ServiceTaskComments from "./ServiceTaskComments";
import ServiceTaskModal from "../Services/ServiceTaskModel";
import Select from "react-select";

export default function ServiceTaskList() {
  const [lists, setLists] = useState([]);
  const [filterValues, setFilterValues] = useState({
    staffId: "00000000-0000-0000-0000-000000000000",
    clientId: "00000000-0000-0000-0000-000000000000",
    categoryId: "00000000-0000-0000-0000-000000000000",
    month: new Date(),
    status: "",
  });
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [pageNumber, setPageNumber] = useState(1);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [staffs, setStaffs] = useState([]);
  const [clients, setClients] = useState([]);
  const [categories, setCategories] = useState([]);
  const [viewRecord, setViewRecord] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [currentServiceTask, setCurrentServiceTask] = useState(null);
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [currentTaskForComments, setCurrentTaskForComments] = useState(null);
  const userId = localStorage.getItem("userId");
  const [showServiceTaskModal, setShowServiceTaskModal] = useState(false);

  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({
      ...filterValues,
      [name]: value,
    });
  };

  const handleSearch = () => {
    GetData(pageNumber);
  };
  const handleClear = () => {
    GetData(pageNumber);
    setFilterValues({
      staffId: "00000000-0000-0000-0000-000000000000",
      clientId: "00000000-0000-0000-0000-000000000000",
      categoryId: "00000000-0000-0000-0000-000000000000",
      month: new Date(),
      status: "",
    });
  };
  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const showViewDetails = (data) => {
    setViewRecord(data);
    setShowDetailModal(true);
  };

  const togglePaymentModal = (serviceTask) => {
    setCurrentServiceTask(serviceTask);
    setPaymentModalVisible(!paymentModalVisible);
  };

  const toggleCommentsModal = (serviceTask) => {
    setCurrentTaskForComments(serviceTask);
    setShowCommentsModal(!showCommentsModal);
  };

  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETTASKACCEPTEDBYSTAFF +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize +
          "&staffId=" +
          filterValues.staffId +
          "&clientId=" +
          filterValues.clientId +
          "&categoryId=" +
          filterValues.categoryId +
          "&month=" +
          moment(filterValues.month).format("YYYY-MM") +
          "&status=" +
          filterValues.status +
          "",
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };

  const GetStaffs = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLSTAFFS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setStaffs(response.data.data);
      });
  };

  const GetClients = () => {
    axios
      .get(
        config.APIACTIVATEURL + config.GETALLCLIENTS + "?userId=" + userId,
        headerconfig
      )
      .then((response) => {
        setClients(response.data.data);
      });
  };

  const GetCategories = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETTOPLEVELCATEGORIES, headerconfig)
      .then((response) => {
        setCategories(response.data.data);
      });
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    GetData(pageNumber);
    GetStaffs();
    GetClients();
    GetCategories();
  }, []);

  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">All Tasks</h4>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setCurrentServiceTask(null);
                      setShowServiceTaskModal(true);
                    }}
                  >
                    Create Task
                  </button>
                </div>
              </div>
            </div>

            <div className="alert alert-success">
              <form autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label>Staff</label>
                      <select
                        name="staffId"
                        value={filterValues.staffId}
                        onChange={handleFilterChange}
                        className="form-select"
                      >
                        <option value="00000000-0000-0000-0000-000000000000">
                          All
                        </option>
                        {staffs.map((s) => (
                          <option key={s.staffId} value={s.staffId}>
                            {s.staffName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label>Client</label>
                      <Select
                        name="clientId"
                        value={
                          clients.find(
                            (c) => c.clientId === filterValues.clientId
                          )
                            ? {
                                value: filterValues.clientId,
                                label:
                                  clients.find(
                                    (c) => c.clientId === filterValues.clientId
                                  )?.clientName || "All",
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          setFilterValues({
                            ...filterValues,
                            clientId: selectedOption
                              ? selectedOption.value
                              : "00000000-0000-0000-0000-000000000000",
                          })
                        }
                        options={[
                          {
                            value: "00000000-0000-0000-0000-000000000000",
                            label: "All",
                          },
                          ...clients.map((c) => ({
                            value: c.clientId,
                            label: c.clientName,
                          })),
                        ]}
                        isSearchable
                        placeholder="Select Client"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="categoryId" className="form-label">
                        Category
                      </label>
                      <select
                        name="categoryId"
                        value={filterValues.categoryId}
                        onChange={handleFilterChange}
                        className={
                          "form-select " + applyErrorClass("categoryId")
                        }
                      >
                        <option value="00000000-0000-0000-0000-000000000000">
                          All
                        </option>
                        {categories.map((c) => (
                          <option key={c.categoryId} value={c.categoryId}>
                            {c.categoryName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label>Month</label>
                      <div className="input-group">
                        <Flatpickr
                          value={filterValues.month}
                          className="form-control"
                          options={{
                            dateFormat: "Y-m",
                            plugins: [
                              new (require("flatpickr/dist/plugins/monthSelect"))(
                                {
                                  shorthand: true,
                                  dateFormat: "M-Y",
                                  theme: "light",
                                }
                              ),
                            ],
                          }}
                          onChange={(date) =>
                            setFilterValues({ ...filterValues, month: date[0] })
                          }
                        />
                        <div className="input-group-text bg-primary border-primary text-white">
                          <i className="ri-calendar-2-line" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <select
                        name="status"
                        value={filterValues.status}
                        onChange={handleFilterChange}
                        className="form-select"
                      >
                        <option value="">All</option>
                        <option value="COMPLETED">COMPLETED</option>
                        <option value="PENDING">PENDING</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={handleClear}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Staff</th>
                            <th>Client</th>
                            <th>Category</th>
                            <th>Service</th>
                            <th>Service Month</th>
                            <th>Cycle</th>
                            <th>Status</th>
                            <th>CreatedDate</th>
                            <th>Updated Date</th>
                            <th>Payment</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.serviceTaskId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <td>{v.staffName || "Unassigned"}</td>
                                <td>{v.clientName}</td>
                                <td>{v.categoryName}</td>
                                <td>{v.serviceName}</td>
                                <td>{moment(v.month).format("MMM-YYYY")}</td>
                                <td>{v.cycle}</td>
                                <td>
                                  <span
                                    className={
                                      "badge " +
                                      (v.status === "COMPLETED"
                                        ? "bg-success"
                                        : "bg-warning")
                                    }
                                  >
                                    {v.status}
                                  </span>
                                </td>
                                <td>
                                  {moment(v.createdDate).format(
                                    "DD MMM YY hh:mm a"
                                  )}
                                </td>
                                <td>
                                  {moment(v.lastUpdatedDate).format(
                                    "DD-MM-YYYY hh:mm a"
                                  )}
                                </td>
                                <td>
                                  <button
                                    className={
                                      "btn " +
                                      (v.amount > 0
                                        ? "btn-warning"
                                        : "btn-info")
                                    }
                                    onClick={() =>
                                      v.amount <= 0 && togglePaymentModal(v)
                                    }
                                    disabled={v.amount > 0}
                                  >
                                    {v.amount > 0 ? " Created" : "Create "}
                                  </button>
                                </td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      title="View"
                                    >
                                      <Link
                                        className="text-info"
                                        onClick={() => showViewDetails(v)}
                                      >
                                        <i className="ri-eye-fill fs-16" />
                                      </Link>
                                    </li>

                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      title="Comments"
                                    >
                                      <Link
                                        className="text-secondary"
                                        onClick={() => toggleCommentsModal(v)}
                                      >
                                        <i className="ri-chat-3-fill fs-16" />
                                      </Link>
                                    </li>
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      title="Edit"
                                    >
                                      <Link
                                        className="text-primary"
                                        onClick={() => {
                                          setCurrentServiceTask(v);
                                          setShowServiceTaskModal(true);
                                        }}
                                      >
                                        <i className="ri-pencil-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="12" className="text-center">
                                No data available.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                        >
                          <Link
                            className="page-link"
                            onClick={() => GetPageData(pageNumber - 1)}
                          >
                            Previous
                          </Link>
                        </li>
                        {renderPageNumbers}
                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                        >
                          <Link
                            className="page-link"
                            onClick={() => GetPageData(pageNumber + 1)}
                          >
                            Next
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* View Details Modal */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Service Task Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {viewRecord && (
            <div className="row">
              <p>
                <strong>Staff:</strong> {viewRecord.staffName || "Unassigned"}
              </p>
              <p>
                <strong>Client:</strong> {viewRecord.clientName}
              </p>
              <p>
                <strong>Category:</strong> {viewRecord.categoryName}
              </p>
              <p>
                <strong>Service:</strong> {viewRecord.serviceName}
              </p>

              <p>
                <strong>Service Month:</strong>{" "}
                {moment(viewRecord.month).format("MMM-YYYY")}
              </p>
              <p>
                <strong>Cycle:</strong> {viewRecord.cycle}
              </p>
              <p>
                <strong>Status:</strong> {viewRecord.status}
              </p>
              <p>
                <strong>Created Date:</strong>{" "}
                {moment(viewRecord.createdDate).format("DD-MM-YYYY hh:mm a")}
              </p>
              <p>
                <strong>Last Updated:</strong>{" "}
                {moment(viewRecord.lastUpdatedDate).format(
                  "DD-MM-YYYY hh:mm a"
                )}
              </p>
              <div className="mt-3">
                <Button
                  variant="info"
                  onClick={() => {
                    setShowDetailModal(false);
                    toggleCommentsModal(viewRecord);
                  }}
                >
                  View Comments
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Payment Modal */}
      <PaymentModal
        currentServiceTask={currentServiceTask}
        paymentModalVisible={paymentModalVisible}
        setPaymentModalVisible={setPaymentModalVisible}
        GetData={GetData}
        pageNumber={pageNumber}
      />

      {/* Comments Modal */}
      {showCommentsModal && (
        <ServiceTaskComments
          serviceTaskId={currentTaskForComments?.serviceTaskId}
          onClose={() => setShowCommentsModal(false)}
          headerconfig={headerconfig}
        />
      )}
      <ServiceTaskModal
        show={showServiceTaskModal}
        onClose={() => {
          setShowServiceTaskModal(false);
          setCurrentServiceTask(null);
        }}
        editData={currentServiceTask}
        refreshData={() => GetData(pageNumber)}
      />
    </div>
  );
}
